import { clsx } from '@alexis/helpers/clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import Button from '@components/Button';
import Dialog from '@components/Dialog';

import WarningIcon from '@icons/warning.svg';

import { getTranslationsState } from '@redux/selectors';

import styles from './VirtualInterlinePopup.module.scss';

interface VirtualInterlinePopupProps {
  isOpen: boolean;
  onClose?: () => void;
}

const VirtualInterlinePopup = ({ isOpen, onClose }: VirtualInterlinePopupProps) => {
  const translations = useSelector(getTranslationsState);

  return (
    <Dialog className={styles.container} isOpen={isOpen} onClose={onClose}>
      <div className={styles.popupContent}>
        <div className={styles.text}>
          <div className={clsx(styles.title, styles.bold)}>
            <WarningIcon />
            {translations.flight_details_self_transfer_title}
          </div>
          <p>{translations.flight_details_self_transfer_description_1}</p>
          <p className={styles.bold}>{translations.flight_details_self_transfer_description_2}</p>
          <p className={styles.red}>{translations.flight_details_self_transfer_description_3}</p>
          <ul>
            <li>{translations.flight_details_self_transfer_bullet_1}</li>
            <li>{translations.flight_details_self_transfer_bullet_2}</li>
            <li>{translations.flight_details_self_transfer_bullet_3}</li>
          </ul>
          <p className={styles.bold}>{translations.flight_details_self_transfer_description_4}</p>
        </div>

        <Button className={styles.button} onClick={onClose}>
          {translations.got_it}
        </Button>
      </div>
    </Dialog>
  );
};

export default VirtualInterlinePopup;
